import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { LanguageService } from '@dss-libs/shared/utility/common-services';

export function languageInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const languageService = inject(LanguageService);

  req = req.clone({
    setHeaders: {
      'Accept-Language': languageService.getLanguage(),
    },
  });

  return next(req);
}
